module.exports = __webpack_public_path__ + "static/media/Avenir-Light.50509881.woff2";